import type { SharedMemoryFormValues } from './types';

/** 默认共享内存配置 */
export const DEFAULT_SHARED_MEMORY: SharedMemoryFormValues = {
  enabled: false,
  sizeLimit: '2Gi',
};

/** 共享内存容量默认值与滑条范围（Gi，与内存配置弹窗一致） */
export const DEFAULT_SHARED_MEMORY_SIZE_MIN = 1;
export const DEFAULT_SHARED_MEMORY_SIZE_MAX = 2048;
export const DEFAULT_SHARED_MEMORY_SIZE_GI = 2;
export const DEFAULT_SHARED_MEMORY_SIZE_MARK_COUNT = 5;
export const SHARED_MEMORY_SIZE_UNIT = 'Gi';

/** 弹窗内共享内存配置字段 */
export const SHARED_MEMORY_MODAL_CONFIG_FIELD = 'sharedMemoryConfig';

/** 卡片 / 弹窗文案 */
export const SHARED_MEMORY_RESOURCE_MODAL_TITLE = '共享内存配置';
export const SHARED_MEMORY_RESOURCE_ICON = 'icon-memory';
